import '../styles/servicios.scss';
import talentos  from '../assets/talentos.svg';
import out  from '../assets/outsourcing.svg';
import capacitaciones  from '../assets/capacitaciones.svg';
import consultoria  from '../assets/consultoria.svg';

export const Servicios = () => {
    return (
        <div className="servicios">
        <div className="servicios-container">
          <h2 data-aos="zoom-in" data-aos-duration="1000">Nuestros servicios</h2>
          <div className="servicios-grid">
            <div data-aos="fade-up" data-aos-delay="100" data-aos-duration="800" className="servicio-card">
              <img src={talentos} alt="Atracción de talentos" />
              <h3>Atracción de talentos</h3>
              <p>
                Captamos y reclutamos a los mejores profesionales mediante estrategias efectivas para conectar empresas con candidatos altamente calificados.
              </p>
            </div>
            <div data-aos="fade-up" data-aos-delay="200" data-aos-duration="800" className="servicio-card">
              <img src={consultoria} alt="Consultoría de capital humano" />
              <h3>Consultoría de capital humano</h3>
              <p>
                Asesoramos en la gestión del talento para mejorar procesos y estrategias, maximizando el potencial de tu equipo.
              </p>
            </div>
            <div data-aos="fade-up" data-aos-delay="300" data-aos-duration="800" className="servicio-card">
              <img src={capacitaciones} alt="Capacitaciones" />
              <h3>Capacitaciones</h3>
              <p>
                Te ayudamos a desarrollar habilidades claves mediante programas de formación que mejoran el rendimiento y potencian el éxito de tu proyecto.
              </p>
            </div>
            <div data-aos="fade-up" data-aos-delay="400" data-aos-duration="800" className="servicio-card">
              <img src={out} alt="Outsourcing" />
              <h3>Outsourcing</h3>
              <p>
                Nos encargamos de la selección, desarrollo y retención del talento, permitiéndote concentrar en el crecimiento de tu negocio.
              </p>
            </div>
          </div>
        </div>
      </div>
      
    )
}
